
    /**
    * 判断是否有权限查看所有主播
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid17167 {}
  /**
 * YResult<Integer> :YResult
 */
export class IResid17167 {
  code?: {};
  msg?: {};
  success?: {};
  /**
   * data
   */
  data?: {};
  exceptionMsg?: {};
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid17167, IResid17167['data'] > = (data?) =>  request({
        method: 'GET',
        url: '/admin/anchor/rihgtAllAnchor',
        params: data
      }) 
  export default http